import React, { useCallback, useContext } from 'react'
import { rootStoreContext } from '@app/components/App'
import { action } from 'mobx'
import { observer } from 'mobx-react-lite'
import classnames from 'classnames'

export const ResultStatus = observer(({ driver }: { driver: any }) => {
  if (driver.formattedTime) {
    return <>{driver.formattedTime}</>
  } else if (driver.lapsBehind) {
    return <>{`+${driver.lapsBehind} lap${driver.lapsBehind > 1 ? 's' : ''}`}</>
  } else {
    return <>DNF</>
  }
})

export const RaceResults = observer(() => {
  const rootStore = useContext(rootStoreContext)
  const clearLapSelection = useCallback(
    action(() => {
      rootStore.hoveredDataset = null
      rootStore.hoveredLap = null
      rootStore.selectedDataset = null
      rootStore.selectedLap = null
    }),
    [rootStore]
  )

  return rootStore.initialized ? (
    <>
      {rootStore.timeDisplayTitle ? (
        <div
          className="cursor-pointer hover:bg-gray-100"
          onClick={clearLapSelection}
          onTouchStart={clearLapSelection}
        >
          <h3
            className="text-sm uppercase font-normal cursor-pointer px-4 ml-2 -mr-4 flex justify-between"
            style={{
              color: '#4669e4',
            }}
          >
            {rootStore.timeDisplayTitle}
          </h3>
          <div className="text-13 text-gray-600 cursor-pointer pl-6 pb-1 font-medium">
            <span>
              <span className="inline-block pl-px">✕</span>
              <span className="pl-1">Clear lap selection</span>
            </span>
          </div>
        </div>
      ) : (
        <h3
          className="text-sm uppercase font-normal cursor-pointer px-4 ml-2 -mr-4 flex justify-between text-gray-600"
          style={{ border: '1px solid white' }}
        >
          Race Results
        </h3>
      )}

      <div className="py-2 pl-1">
        {rootStore.timeDisplayList.length === 0 ? (
          <div className="italic text-center font-medium text-13 text-gray-600">
            No times
          </div>
        ) : (
          rootStore.timeDisplayList.map((driver: any) => (
            <div
              key={driver.driverId}
              className={classnames('pb-1 text-13 cursor-pointer', {
                'font-medium': driver.driverSelected,
              })}
              onClick={() => {
                rootStore.selectedDriver = driver.driverId
              }}
              onMouseOver={() => {
                rootStore.hoveredDriver = driver.driverId
              }}
              onMouseOut={() => {
                rootStore.hoveredDriver = null
              }}
            >
              <div className="flex hover:bg-gray-100">
                <span className="inline-block w-6 text-right">
                  {driver.positionOrder}
                </span>
                <span className="px-1">
                  <svg
                    width="0.9em"
                    height="0.9em"
                    className="inline"
                    style={{
                      verticalAlign: '-0.02em',
                    }}
                  >
                    <circle
                      fill={rootStore.pointColor(driver.driverId).css}
                      cx="0.45em"
                      cy="0.45em"
                      r="0.35em"
                    />
                  </svg>
                </span>
                <span className="flex-grow">{driver.name}</span>
                <span className="flex-grow text-gray-600 pl-2 text-right">
                  <ResultStatus driver={driver} />
                </span>
              </div>
            </div>
          ))
        )}
        {rootStore.selectedDriver !== null &&
          rootStore.timeDisplayList.length > 0 && (
            <div
              className="text-13 text-gray-600 cursor-pointer pl-6 pt-1 font-medium hover:bg-gray-100"
              onClick={() => (rootStore.selectedDriver = null)}
            >
              <span className="pr-1 pl-1">
                <span className="inline-block pl-px">✕</span>
                <span className="pl-1">Clear driver selection</span>
              </span>
            </div>
          )}
      </div>
    </>
  ) : null
})
